import * as globals from '@wandb/weave/common/css/globals.styles';
import {hexToRGB} from '@wandb/weave/common/css/globals.styles';
import {IconBellNotifications} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, Dropdown, Input, Popup} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import ActiveRunIndicator from './ActiveRunIndicator';

export const IconContainer = styled.div<{
  location: 'search nav' | 'runs table';
}>(props =>
  props.location !== 'runs table'
    ? css`
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        ${props.location === 'search nav' && `margin-right: 7px;`}
      `
    : css`
        position: absolute;
        right: 0;
        background: transparent;
        margin: 0;
        display: flex;
        align-items: center;
      `
);

export const Content = styled.div`
  padding: 12px;
  @media (max-width: 710px) {
    max-width: 100% !important;
  }
`;

export const Header = styled.h2`
  font-size: 20px;
  margin-bottom: calc(${globals.spu} * 2);
  color: black;
`;

export const Row = styled.div<{isMobile?: boolean}>`
  display: flex;
  flex-direction: ${props => (props.isMobile ? 'column' : 'row')};
  align-items: ${props => (props.isMobile ? 'flex-start' : 'center')};
  justify-content: space-between;
  border-bottom: 1px solid ${globals.gray700};
`;

export const RowSimple = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${globals.spu};
  flex-direction: column;
  @media (max-width: 710px) {
    max-width: 100% !important;
  }
`;

export const Div = styled.div`
  margin-top: ${globals.spu};
  @media (max-width: 710px) {
    max-width: 100% !important;
  }
`;

export const CustomAlertDesc = styled.div`
  margin-top: calc(${globals.spu} * 2);
`;

export const CustomAlertCodeWrapper = styled.div`
  .code__block {
    padding: 0;
  }
  .copyable__item {
    padding: calc(${globals.spu} * 2) 0 calc(${globals.spu} * 2) ${globals.spu};
  }
`;

export const SubscriptionStatusLabel = styled.div`
  font-size: 14px;
  color: ${globals.gray400};
  font-weight: 600;
`;

export const th = styled.div<{wide?: boolean}>`
  font-size: 14px;
  color: ${globals.gray700};
  width: ${props => (props.wide ? 50 : 25)}%;
  font-weight: 600;
`;

export const td = styled.div<{wide?: boolean; isMobile?: boolean}>`
  font-size: ${globals.fontSizeStandard};
  color: ${globals.gray700};
  margin: calc(${globals.spu} * 2) 0px;
  width: ${props => (props.isMobile ? 100 : props.wide ? 50 : 25)}%;
  display: flex;
  align-items: center;
  @media (max-width: 710px) {
    margin: 0 0 calc(${globals.spu} * 2);
    &:first-child {
      margin-top: calc(${globals.spu} * 2);
    }
  }
`;

export const IconWrapper = styled.span<{
  $isInNav?: boolean;
  $showAdminBanner?: boolean;
}>`
  display: inline-block;
  height: ${p => (p.$isInNav ? 40 : 20)}px;
  cursor: pointer;
  border-radius: 4px;

  ${p =>
    p.$isInNav &&
    css`
      padding: 8px;
      &:hover {
        background: rgba(250, 250, 254, 0.1);
      }
      &:focus-visible {
        outline: 2px solid rgba(0, 150, 173, 0.6);
      }
    `}

  color: ${props =>
    props.$showAdminBanner
      ? hexToRGB(globals.WHITE, 0.5)
      : props.$isInNav
        ? globals.MOON_500
        : globals.successText};
  &:hover {
    color: ${props =>
      props.$isInNav ? hexToRGB(globals.WHITE, 0.8) : globals.successDark};
  }
`;

export const Icon = styled(IconBellNotifications)`
  width: 24px;
  height: 24px;
`;

export const ActiveRunDot = styled(ActiveRunIndicator)`
  > div {
    margin: 0 calc(${globals.spu} / 2);
  }
  :hover {
    cursor: pointer;
  }
`;

export const StyledPopup = styled(Popup)`
  &&& {
    background-color: white;
    color: black;
    min-width: 700px;
    box-shadow: 0 2px 4px 0 rgb(34 36 38 / 12%),
      0 2px 10px 0 rgb(34 36 38 / 15%);
    @media (max-width: 710px) {
      min-width: 97% !important;
    }
    margin: 0;
    margin-top: -${globals.largeSpu};
  }
`;

export const TextInput = styled(Input)`
  &&& {
    > input {
      background-color: ${globals.white};
      color: ${globals.gray800};
      border: 1px solid ${globals.gray600};
      border-radius: 4px;
      width: 50px;
      height: 32px;
      margin-left: ${globals.spu};
    }
  }
`;

export const DropdownInput = styled(Dropdown)`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-weight: 600;
    height: 32px;
    .dropdown.icon {
      font-size: 12px;
      margin-left: ${globals.spu};
    }
  }
`;

export const BlueButton = styled(Button)`
  &&& {
    background-color: ${globals.primary};
    transition: all 0.2s ease;
    &:hover {
      background-color: ${globals.primaryDark};
    }
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const LinkDiv = styled.div`
  margin-right: ${globals.fontSizeStandard};
  color: ${globals.gray400};
  > a {
    color: ${globals.gray500};
  }
`;

export const MobileAlertTypeLabel = styled.div`
  min-width: 55px;
`;

export const AlertLabel = styled.h3`
  font-weight: 600;
  font-size: 1rem;
  margin: 0;
`;
